import { UIEvent } from 'react';
import config from 'config';
import { app } from 'core';
import { getWhatsAppLink } from 'core/utilities';
import { Icon } from 'ui/components/primitives';
import { ListComponentsTalkTo } from './components.styles';

export const WhatsappLink = ({
  handleTrackClick,
}: {
  handleTrackClick: (event: UIEvent<HTMLAnchorElement>) => void;
}) => {
  const isMobile = app.hooks.useApp('isMobile');

  return (
    <ListComponentsTalkTo.Li>
      <ListComponentsTalkTo.Link
        data-label="whatsapp"
        onClick={handleTrackClick}
        to={getWhatsAppLink(
          config.communication.sac.whatsapp,
          isMobile,
          config.communication.sac.whatsappText,
        )}
      >
        <Icon.SocialWhatsapp size={'s'} aria-hidden="true" />
        Whatsapp: {config.communication.sac.whatsapp}
      </ListComponentsTalkTo.Link>
    </ListComponentsTalkTo.Li>
  );
};
